export const smartDocStaticParamType_Time = 'time';
//# sourceMappingURL=types.js.map